import type { FieldTree } from '@angular/forms/signals';
import { readonly } from '@angular/forms/signals';

import type { ShadowFeatureSettings, ShadowValues } from '@sites/entity-core';
import { shadowFeature } from '@sites/entity-core';

// Thunk is mandatory: see `createBorderAccessors`.
export const createShadowAccessors = (getField: () => FieldTree<ShadowFeatureSettings>) => ({
    get shadow() {
        return getField();
    },
    setShadow: (patch: Partial<Omit<ShadowFeatureSettings, 'version'>>) => {
        getField()().value.update((current) => ({ ...current, ...patch }));
    },

    setShadowEnabled: (value: boolean) => {
        getField().isEnabled().value.set(value);
    },
    setShadowValues: (value: ShadowValues | null) => {
        getField().settings().value.set(value);
    },
});

export type ShadowAccessors = ReturnType<typeof createShadowAccessors>;

export const applyShadowFieldRules = (shadowPath: any): void => {
    readonly(shadowPath.version);
};

export { shadowFeature };
